import { render, staticRenderFns } from "./WelcomeWizard.vue?vue&type=template&id=063693a0&scoped=true"
import script from "./WelcomeWizard.vue?vue&type=script&lang=js"
export * from "./WelcomeWizard.vue?vue&type=script&lang=js"
import style0 from "./WelcomeWizard.vue?vue&type=style&index=0&id=063693a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "063693a0",
  null
  
)

export default component.exports